import { render, staticRenderFns } from "./DataSetCreate.vue?vue&type=template&id=4afb0d0d&scoped=true&"
import script from "./DataSetCreate.vue?vue&type=script&lang=ts&"
export * from "./DataSetCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb0d0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
